import styled, {createGlobalStyle} from "styled-components";
import {Link} from 'react-router-dom';
import {Link as ScrollLink} from 'react-scroll';
import {Grid, Container,} from '../ReUsableStyles';
import LogoFont from '../fonts/Bacalisties-2OnXo.ttf';


export const FooterSection = styled.footer`
    padding-top:2rem;
`;

export const FooterBackground = styled.div`
    background-color: var(--first-color-second);
    padding:2rem 0 3rem;
`;

export const FooterContainer = styled.div`
        ${Container};    
        ${Grid};
        row-gap:3.5rem;
`;

export const FooterTitle = styled.h1`
    @font-face{
        font-family: "Logo";
        src: url(${LogoFont});
        
    }
    font-family:"Logo";
    font-size: var(--h1-font-size);
    margin-bottom: var(--mb-0-25);
    color: #fff;
`;

export const FooterSubtitle = styled.span`
    font-size:var(--small-font-size);
    color: #fff;
`;

export const FooterLinksWrapper = styled.ul`
    display:flex;
    flex-direction:column;
    row-gap: 1.5rem;
`;

export const FooterLink = styled(ScrollLink)`
    color: #fff;
    &:hover{
        color: var(--first-color-lighter);
    }
    cursor:pointer;
`;

export const FooterSocialsWrapper = styled.div`

`;

export const FooterSocial = styled(Link)`
    margin-right: var(--mb-1-5);   
    color: #fff;
    &:hover{
        color: var(--first-color-lighter);
    }
`;

export const FooterCopyright = styled.p`
    font-size:var(--smaller-font-size);
    text-align: center;
    color: var(--text-color-light);
    margin-top: var(--mb-3);
`;